export default function acmPortalMessageToAll(params) {
    this.rest.post('acmPortalMessageToAll', {}, (resp) => {
        if (resp.status === true) {
            if (resp.message) {
                this.popup(resp.message);
            }
        }
    });
}
